export default class FormControl {
    constructor(options) {
        this.localization = options.localization;
        this.actionLocalization = options.actionLocalization;
        this.container = options.container;
        this.metadata = null;
        this.otherParameters = options.otherParameters != null ? options.otherParameters : {};
        this.actionButtons = [];
        this.isPreview = false;
        this.uniqueId = 'formControl' + options.pageGuid;
        this.pageGuid = options.pageGuid;
        this.uniqueModalId = this.uniqueId + '-modal';
        this.uniqueModalInnerId = this.uniqueId + '-modal-inner';
        this.lastChosenTab = null;
        this.objectId = options.objectId;
        this.formId = options.formId;
        this.layoutId = options.layoutId;
        this.isFilter = options.isFilter;
        this.listControl = options.listControl;
        this.currentActionId = -1;
        this.generalResources = options.generalResources;
        this.customFormResources = options.customFormResources;
        this.parentGuid = options.parentGuid;
        if (this.parentGuid != null && this.parentGuid != '') {
            $('#sublist-modal-' + this.parentGuid.replaceAll('listControl', '')).siblings('.k-window-titlebar').find('[aria-label="Close"]').attr('id', 'form-panel-close-' + this.pageGuid);
            $('#form-panel-close-' + this.pageGuid).hide();
        }

        this.uploadedFiles = {};
        this.actionGeom = {};
        this.formGeomEdited = false;
        this.formItemPrefix = 'entity-form-item-';
        this.commands = [];

        this.allowEdit = false;
        this.allowDelete = false;
        this.dataItem = {};
        this.saveDataItem = {
            idForm: this.formId,
            pkVal: this.objectId,
            values: {}
        };

        window[this.uniqueId] = this;

        // control items
        this.saveButtonId = 'form-save-button-' + this._generateUUID();
        this.cancelButtonId = 'form-cancel-button-' + this._generateUUID();
        this.clearFilterButtonId = 'clear-filter-button-' + this._generateUUID();
        this.searchFilterButtonId = 'search-filter-button-' + this._generateUUID();

        if (options.isPreview != null) {
            this.isPreview = options.isPreview;
            if (this.isPreview) {
                this.allowEdit = true;
                this.allowDelete = true;
            }
        }
        this.featureSelectionChangedHandler = this._handleMapElementSelection();
    }

    //public methods
    loadForm(metadata, actionButtons) {
        if (metadata != null && metadata.Items != null && metadata.Items.length > 0) {
            this._disposeForm();
            this.metadata = metadata;
            this.actionButtons = actionButtons;

            if (window['onBeforeFormLoaded' + this.pageGuid] != null) {
                window['onBeforeFormLoaded' + this.pageGuid]();
            }

            this._initForm();
        }
    }

    reloadForm() {
        if (window['onBeforeFormLoaded' + this.pageGuid] != null) {
            window['onBeforeFormLoaded' + this.pageGuid]();
        }

        this._initForm();
    }

    getFieldMetadataById(id) {
        let item = this._searchFieldByUiName(this.metadata, id);
        return item;
    }

    getFieldById(id) {
        let item = this._searchFieldByUiName(this.metadata, id);
        let value = null;
        if (item != null) {
            switch (item.CtlType) {
                case 'Switch': value = $("#" + item.UniqueClientId).data('kendoSwitch');
                    break;
                case 'IntegerTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox');
                    break;
                case 'DatePicker': value = $("#" + item.UniqueClientId).data("kendoDatePicker");
                    break;
                case 'NumericTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox');
                    break;
                case 'TextBox': value = $("#" + item.UniqueClientId);
                    break;
                case 'TextArea': value = $("#" + item.UniqueClientId);
                    break;
                case 'DateTimePicker': value = $("#" + item.UniqueClientId).data("kendoDateTimePicker");
                    break;
                case 'ComboBox': value = $("#" + item.UniqueClientId).data('kendoComboBox');
                    break;
                default: break;
            }
        }

        return value;
    }

    getFieldValueById(id) {
        let item = this._searchFieldByUiName(this.metadata, id);
        let value = null;
        if (item != null) {
            switch (item.CtlType) {
                case 'Switch': value = $("#" + item.UniqueClientId).data('kendoSwitch').check();
                    break;
                case 'IntegerTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox').value();
                    break;
                case 'DatePicker': value = $("#" + item.UniqueClientId).data("kendoDatePicker").value();
                    break;
                case 'NumericTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox').value();
                    break;
                case 'TextBox': value = $("#" + item.UniqueClientId).val();
                    break;
                case 'TextArea': value = $("#" + item.UniqueClientId).val();
                    break;
                case 'DateTimePicker': value = $("#" + item.UniqueClientId).data("kendoDateTimePicker").value();
                    break;
                case 'ComboBox': value = $("#" + item.UniqueClientId).data('kendoComboBox').value();
                    break;
                default: break;
            }
        }

        return value;
    }

    executeCommandById(id, params) {
        let foundCommands = this.commands.filter((row) => { return row.Id == id });

        if (foundCommands.length > 0) {
            return this._executeCommand(foundCommands[0], params);
        } else {
            throw 'Command does not exist!';
        }
    }

    executeCommandByName(name, params) {
        let foundCommands = this.commands.filter((row) => { return row.Name == name });

        if (foundCommands.length > 0) {
            if(foundCommands.length > 0) {
                return this._executeCommand(foundCommands[0], params);
            } else {
                throw 'Command does not exist!';
            }
        } else {
            throw 'Command does not exist!';
        }
    }

    showLoadingPanel(target) {
        Swal.fire({
            target: target,
            allowOutsideClick: false,
            onBeforeOpen: () => {
                Swal.showLoading();
                $('body').css('overflow', 'auto');
                //$(target).find('.swal2-container').css('margin-left', '0.65rem');
            },
            customClass: {
                container: 'position-absolute'
            }
        });
    }

    _executeCommand(command, params) {
        if (command.Type == 'CLIENT') {
            return new Promise((resolve, reject) => {
                try {
                    let result = window['command_' + this.pageGuid + '_' + command.Id]();

                    resolve(result);
                } catch (err) {
                    reject(err);
                }
            });
        } else if (command.Type == 'SERVER_WITH_RESULT') {
            return new Promise((resolve, reject) => {
                try {
                    let postData = {
                        id: command.Id,
                        idEntity: this.metadata.IdEntity,
                        params: {}
                    };

                    if (params != null) {
                        postData.params = params;
                    } else {
                        for (var i = 0; i < command.Parameters.length; i++) {
                            let value = this.getFieldValueById(command.Parameters[i]);

                            if (command.Parameters[i] != 'User.Id') {
                                let type = this.getFieldMetadataById(command.Parameters[i]).EntityField.DataType;

                                postData.params[command.Parameters[i]] = {
                                    value: value,
                                    type: type
                                }
                            }
                        }
                    }

                    let commandUrl = rootUrl + 'EntityForm/ExecuteCommandWithResult';

                    $.ajax({
                        type: "POST",
                        url: commandUrl,
                        async: true,
                        data: JSON.stringify(postData),
                        contentType: "application/json; charset=utf-8",
                        success: (result) => {
                            if (result != null) {
                                var resp = JSON.parse(result);

                                if (resp.length == 0) {
                                    resolve(null);
                                } else if (resp.length == 1) {
                                    resolve(resp[0]);
                                } else {
                                    resolve(resp);
                                }
                            }
                        },
                        error: (e) => {
                            reject(e)
                        }
                    });
                } catch (err) {
                    reject(err);
                }
            });
        } else if (command.Type == 'SERVER_NO_RESULT') {
            return new Promise((resolve, reject) => {
                try {
                    let postData = {
                        id: command.Id,
                        idEntity: this.metadata.IdEntity,
                        params: {}
                    };

                    if (params != null) {
                        postData.params = params;
                    } else {
                        for (var i = 0; i < command.Parameters.length; i++) {
                            let value = this.getFieldValueById(command.Parameters[i]);

                            if (command.Parameters[i] != 'User.Id') {
                                let type = this.getFieldMetadataById(command.Parameters[i]).EntityField.DataType;

                                postData.params[command.Parameters[i]] = {
                                    value: value,
                                    type: type
                                }
                            } 
                        }
                    }

                    let commandUrl = rootUrl + 'EntityForm/ExecuteCommandWithoutResult';

                    $.ajax({
                        type: "POST",
                        url: commandUrl,
                        async: true,
                        data: JSON.stringify(postData),
                        contentType: "application/json; charset=utf-8",
                        success: (result) => {
                            if (result != null) {
                                if (result.status == true) {
                                    resolve(true);
                                } else {
                                    resolve(false);
                                }
                            } else {
                                resolve(false);
                            }
                        },
                        error: (e) => {
                            reject(e)
                        }
                    });
                } catch (err) {
                    reject(err);
                }
            });
        } else {
            throw 'Command type not implemented!';
        }
    }

    //private methods
    _searchFieldByUiName(item, name) {
        let found = null;

        if (item.TypeName == 'UIFieldControlDto' && item.Name == name) {
            return item;
        }

        if (item.Items != null && item.Items.length > 0) {
            for (var i = 0; i < item.Items.length; i++) {
                let childFound = this._searchFieldByUiName(item.Items[i], name);
                if (childFound != null) {
                    found = childFound;
                }
            }
        }

        return found;
    }

    _initForm() {
        let commandsUrl = rootUrl + 'EntityForm/GetXpCommandsRuntime?idForm=' + this.formId;
        $.ajax({
            type: "GET",
            url: commandsUrl,
            contentType: "application/json; charset=utf-8",
            success: (result) => {
                this.commands = result;
                if (this.parentGuid != null && this.parentGuid != '') {
                    $('#' + this.container).css('max-height', '80vh');
                }
                
                $('#' + this.container)[0].innerHTML = this._getTemplate();

                if (!this.isPreview) {
                    this.showLoadingPanel('[id="' + this.metadata.UniqueClientId + '-wrapper"]');
                }

                this._initControls(this.metadata);
                this._bindChangeEvents(this.metadata);

                if (this.lastChosenTab != null) {
                    this._tabOnClick(this.lastChosenTab);
                }

                if (!this.isPreview && $('#panel-hdr-title').length > 0) {
                    $('#panel-hdr-title')[0].innerHTML = this.metadata.Name;
                }

                if (this.parentGuid != null && this.parentGuid != '') {
                    $('#' + window[this.parentGuid].modalInner + '_wnd_title')[0].innerHTML = this.metadata.Name;
                }

                if (!this.isPreview) {
                    if (!this.isFilter) {
                        this._initData();
                    } else {
                        this._populateItem(this.metadata);
                    }
                } else {
                    this._populateItem(this.metadata);
                }

                //this._populateItem(this.metadata);

                if (this.isFilter || this.isPreview) {
                    this._addButtonEvents();
                    Swal.close();
                }

                if (this.parentGuid != null && this.parentGuid != '') {
                    window[this.parentGuid].centerModal();
                }
            },
            error: (e) => {
                toastr.error(e.responseText, '@resources["GetCommandsError"]');
            }
        });
    }

    centerForm() {
        if (this.parentGuid != null && this.parentGuid != '') {
            window[this.parentGuid].centerModal();
        }
    }

    // populate the created controls

    _initData() {
        let dataUrl = rootUrl + 'EntityForm/GetData?idForm=' + this.formId + '&pkVal=' + this.objectId;

        if (this.otherParameters != null && this.otherParameters.parentPkVal != null ) {
            dataUrl += '&pkValCurrent=' + this.otherParameters.parentPkVal;
        }

        if (this.otherParameters != null && this.otherParameters.parentIdAction != null) {
            dataUrl += '&idAction=' + this.otherParameters.parentIdAction;
        }

        $.ajax({
            type: "GET",
            url: dataUrl,
            contentType: "application/json; charset=utf-8",
            success: (result) => {
                this._populateData(result);
                this._checkVisibility(this.metadata);
                this._addButtonEvents();
                Swal.close();
                if (window['onFormLoaded' + this.pageGuid] != null) {
                    window['onFormLoaded' + this.pageGuid]();
                }

                if (this.parentGuid != null && this.parentGuid != '') {
                    window[this.parentGuid].centerModal();
                }
            },
            error: (e) => {
                toastr.error(e.responseText, this.getResource('GetDataError'));
                Swal.close();
            }
        });
    }

    _addButtonEvents() {
        if (this.isFilter) {
            $('#' + this.searchFilterButtonId).on('click', () => {
                let filters = this.getFormData();

                if (this.listControl != null) {
                    this.listControl.notifyFilters(filters);
                }
            });

            $('#' + this.clearFilterButtonId).on('click', () => {
                this._clearData(this.metadata);

                let filters = this.getFormData();

                if (this.listControl != null) {
                    this.listControl.notifyFilters(filters);
                }
            });
        }
        
        if (this.actionButtons != null) {
            let cancelButtons = this.actionButtons.filter(row => { return row.SubType == 'CANCEL' });

            if (cancelButtons.length > 0) {
                $('#form-panel-close-' + this.pageGuid).show();
            } else {
                $('#form-panel-close-' + this.pageGuid).hide();
            }

            this.actionButtons.forEach(actionButton => {
                if (actionButton.SubType == 'SAVE' || actionButton.SubType == 'APPLY') {
                    if (this.allowEdit || this.isPreview) {
                        $('#form-action-' + actionButton.Id).show();
                    }
                } else if (actionButton.SubType == 'DELETE') {
                    if (this.allowDelete || this.isPreview) {
                        $('#form-action-' + actionButton.Id).show();
                    }
                } else {
                    $('#form-action-' + actionButton.Id).show();
                }

                $('#form-action-' + actionButton.Id).on('click', (e) => {
                    switch (actionButton.SubType) {
                        case 'EDIT_GEOMETRY': this._editGeometry(actionButton);
                            break;
                        case 'SHOW_IN_MAP': this._showGeometry(actionButton);
                            break;
                        case 'SELECT_FROM_MAP': this._selectMapElement(actionButton);
                            break;
                        case 'DELETE': this._deleteElement(actionButton);
                            break;
                        case 'FORM': this._showForm(actionButton);
                            break;
                        case 'JS': this._handleJavascriptAction(actionButton);
                            break;
                        case 'CANCEL': this._cancelForm();
                            break;
                        case 'SAVE': this._saveForm();
                            break;
                        case 'APPLY': this._applyFormChanges();
                            break;
                        default: break;
                    }
                });
            });
        }
    }

    _cancelForm() {
        if (this.parentGuid != null && this.parentGuid != '') {
            window[this.parentGuid].closeModal();
        } else {
            if ($('#' + this.container).closest('.k-window-content').length > 0) {
                $('#' + this.container).closest('.k-window-content').data('kendoWindow').close();
            } else {
                history.back();
            }
        }
    }

    _saveForm() {
        this.saveDataItem.values = {};
        this._storeData(this.metadata);
        this._storeGeomData();
        this._saveData(false);
    }

    _applyFormChanges() {
        this.saveDataItem.values = {};
        this._storeData(this.metadata);
        this._storeGeomData();
        this._saveData(true);
    }

    _editGeometry(actionButton) {
        if (mapCtrl != null) {
            this.formGeomEdited = true;
            let layerSettings = mapCtrl.config.layersSettings.filter(row => { return row.layerId == actionButton.IdLayerTarget })[0];

            let mapLayerId = layerSettings.id;
            let featureId = this.objectId;

            if (featureInteractionControl.editSuspended == true) {
                featureInteractionControl.isFromForm = true;
                featureInteractionControl.startEdit(mapLayerId, null, (response) => {
                    if (response != null && response.features != null && response.features.length > 0) {
                        this.actionGeom[actionButton.Id] = { wkt: response.features[0].geom, srid: response.features[0].srid };
                    }
                    $('#' + this.container).closest('.k-widget.k-window').show();
                    $('.k-overlay').show();
                }, () => {
                    $('#' + this.container).closest('.k-widget.k-window').show();
                    $('.k-overlay').show();
                });
            }

            let scale = null;

            if (layerSettings.geometryType == 'POINT') {
                scale = 500;
            }

            mapCtrl.showFeature(mapLayerId, featureId, scale, () => {
                $('.k-widget.k-window').hide();
                $('.k-overlay').hide();
                featureInteractionControl.isFromForm = true;
                featureInteractionControl.startEdit(mapLayerId, null, (response) => {
                    if (response != null && response.features != null && response.features.length > 0) {
                        this.actionGeom[actionButton.Id] = { wkt: response.features[0].geom, srid: response.features[0].srid };
                    }
                    $('#' + this.container).closest('.k-widget.k-window').show();
                    $('.k-overlay').show();
                }, () => {
                    $('#' + this.container).closest('.k-widget.k-window').show();
                    $('.k-overlay').show();
                });
            }, (e) => {
                if (e == 'Feature has no geometry' || e.message == 'Unexpected token \'<\', "<?xml vers"... is not valid JSON') {
                    $('.k-widget.k-window').hide();
                    $('.k-overlay').hide();
                    featureInteractionControl.isFromForm = true;
                    featureInteractionControl.startInsert(mapLayerId, (response) => {
                        if (response != null && response.features != null && response.features.length > 0) {
                            this.actionGeom[actionButton.Id] = { wkt: response.features[0].geom, srid: response.features[0].srid };
                        }
                        $('#' + this.container).closest('.k-widget.k-window').show();
                        $('.k-overlay').show();
                    }, () => {
                        $('#' + this.container).closest('.k-widget.k-window').show();
                        $('.k-overlay').show();
                    });
                } else {
                    toastr.error(e);
                }
            });
        }
    }

    _selectMapElement(actionButton) {
        $('.k-widget.k-window').hide();
        $('.k-overlay').hide();
        $event.register("featureSelectionChanged", this.featureSelectionChangedHandler, $('#' + this.container)[0]);
    }

    _handleMapElementSelection() {
        let featureSelectionChangedHandler = (eventName, eventArgs, sender) => {
            $('#' + this.container).closest('.k-widget.k-window').show();
            $('.k-overlay').show();

            if (eventArgs.layerId != null) {
                $event.unregister("featureSelectionChanged", this.featureSelectionChangedHandler, $('#' + this.container)[0]);
                this.currentSelectedLayer = eventArgs.layerId;
                this.currentSelectedFeature = eventArgs.featureId;
            }
        }

        return featureSelectionChangedHandler;
    }

    _showGeometry(actionButton) {
        if (mapCtrl != null) {
            let layerSettings = mapCtrl.config.layersSettings.filter(row => { return row.layerId == actionButton.IdLayerTarget })[0];

            let mapLayerId = layerSettings.id;
            let featureId = this.objectId;

            let scale = null;

            if (layerSettings.geometryType == 'POINT') {
                scale = 500;
            }

            mapCtrl.showFeature(mapLayerId, featureId, scale, () => { }, () => { });
        }
    }

    _deleteElement(actionButton) {
        confirmDialog.fire({
            title: this._getCustomFormResource('DeleteItemTitle'),
            text: this._getCustomFormResource('DeleteItemContent'),
        }).then((result) => {
            if (result.value) {
                let url = rootUrl + 'Entity/DeleteData';
                let data = {
                    pkVal: this.objectId,
                    idEntity: this.metadata.IdEntity
                };

                $.ajax({
                    type: "POST",
                    url: url,
                    async: true,
                    data: JSON.stringify(data),
                    contentType: "application/json; charset=utf-8",
                    success: (result) => {
                        if (this.parentGuid == null || this.parentGuid == '') {
                            history.back();
                        } else {
                            if (mapCtrl != null) {
                                mapCtrl.refresh();
                            }
                            window[this.parentGuid].closeModal();
                        }
                    },
                    error: (e) => {
                        toastr.error(this._getCustomFormResource('RemoveItemError'));
                    }
                });
            }
        });
    }

    _showForm(actionButton) {
        let url = rootUrl + 'EntityForm/EntityFormRuntime';

        //idform
        if (actionButton.IdFormTarget != null && actionButton.IdFormTarget != '') {
            url += '?idForm=' + actionButton.IdFormTarget;            
        } else {
            url += '?idForm=' + this.getFieldData(actionButton.IdFormUIObjTarget);
        }

        //pkVal
        if (actionButton.NewRecord) {
            //nothing to do
        }
        else {
            if (actionButton.IdUIObjTarget != null) {
                url += '&pkVal=' + this.getFieldData(actionButton.IdUIObjTarget);
            } else {
                url += '&pkVal=' + this.objectId;
            }
        }

        url += '&idaction=' + actionButton.Id + '&pkValCurrent=' + this.objectId;

        if (this.parentGuid == null || this.parentGuid == '') {
            $.pjax({ url: url, container: '#js-page-content', timeout: 10000 })
        } else {
            window[this.parentGuid]._initModal(url);
        }
    }

    _handleJavascriptAction(actionButton) {
        if (window['btn_' + actionButton.Id + '_onClick'] != null) {
            window['btn_' + actionButton.Id + '_onClick']();
        }
    }

    getFieldData(id) {
        let formData = this.getFormData();
        return formData.values['fld_' + id];
    }

    getFormData() {
        this._storeData(this.metadata);
        this._storeGeomData();
        return this.saveDataItem;
    }

    _storeGeomData() {
        let keys = Object.keys(this.actionGeom);
        keys.forEach(key => {
            this.saveDataItem.values['act_' + key] = this.actionGeom[key];
        });
    }

    // send data to backend

    _saveData(reloadData) {
        let saveDataUrl = rootUrl + "EntityForm/SaveData";

        this.saveDataItem.otherParameters = this.otherParameters;

        if (window['onBeforeFormSaved' + this.pageGuid] != null) {
            window['onBeforeFormSaved' + this.pageGuid](this.saveDataItem);
        }

        $.ajax({
            type: "POST",
            url: saveDataUrl,
            async: true,
            data: JSON.stringify(this.saveDataItem),
            contentType: "application/json; charset=utf-8",
            success: (result) => {
                if (window['onAfterFormSaved' + this.pageGuid] != null) {
                    window['onAfterFormSaved' + this.pageGuid](this.saveDataItem, result);
                }

                if (result != null && (result.Error == null || result.Error == '')) {
                    if (!reloadData) {
                        if (this.formGeomEdited) {
                            featureInteractionControl.stopEdit();
                        }

                        if (this.parentGuid == null || this.parentGuid == '') {
                            if ($('#' + this.container).closest('.k-window-content').length > 0) {
                                $('#' + this.container).closest('.k-window-content').data('kendoWindow').close();
                            } else {
                                history.back();
                            }
                        } else {
                            window[this.parentGuid].closeModal();
                        }
                    } else {
                        if (this.formGeomEdited) {
                            featureInteractionControl.stopEdit();
                        }

                        if (result.jsonEntity != null && result.jsonEntity != '') {
                            let parsedResult = JSON.parse(result.jsonEntity);

                            let newId = parsedResult.pkVal;

                            if (this.objectId != newId) {
                                this.objectId = newId;
                                this.saveDataItem.pkVal = this.objectId;
                            }
                        }

                        this.reloadForm();
                    }
                } else if (result == null || result.Error == null) {
                    toastr.error(this.getResource('GetLayoutError'));
                } else {
                    toastr.error(result.Error);
                }
            },
            error: (e) => {
                toastr.error(this.getResource('GetLayoutError'));
            }
        });
    }

    // clear input data

    _clearData(item) {
        if (item.TypeName == 'UIFieldControlDto') {
            if (item.CtlType != null) {
                switch (item.CtlType) {
                    case 'Switch': $("#" + item.UniqueClientId).data('kendoSwitch').check(false);
                        break;
                    case 'IntegerTextBox': $("#" + item.UniqueClientId).data('kendoNumericTextBox').value(null);
                        break;
                    case 'DatePicker': $("#" + item.UniqueClientId).data('kendoDatePicker').value(null);
                        break;
                    case 'NumericTextBox': $("#" + item.UniqueClientId).data('kendoNumericTextBox').value(null);
                        break;
                    case 'TextBox': $("#" + item.UniqueClientId).val(null);
                        break;
                    case 'TextArea': $("#" + item.UniqueClientId).val(null);
                        break;
                    case 'DateTimePicker': $("#" + item.UniqueClientId).data('kendoDateTimePicker').value(null);
                        break;
                    case 'ComboBox': $("#" + item.UniqueClientId).data('kendoComboBox').value(null);
                        break;
                    case 'File': break;
                    default: break;
                }
            }
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._clearData(child);
            });
        }
    }

    // store input data

    _storeData(item) {
        if (item.TypeName == 'UIFieldControlDto') {
            if (item.CtlType != null) {
                switch (item.CtlType) {
                    case 'Switch': this._storeSwitchData(item);
                        break;
                    case 'IntegerTextBox': this._storeIntegerTextBoxData(item);
                        break;
                    case 'DatePicker': this._storeDatePickerData(item);
                        break;
                    case 'NumericTextBox': this._storeNumericTextBoxData(item);
                        break;
                    case 'TextBox': this._storeTextBoxData(item);
                        break;
                    case 'TextArea': this._storeTextAreaData(item);
                        break;
                    case 'DateTimePicker': this._storeDateTimePickerData(item);
                        break;
                    case 'ComboBox': this._storeComboBoxData(item);
                        break;
                    case 'File': this._storeFileData(item);
                        break;
                    default: break;
                }
            }
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._storeData(child);
            });
        }
    }

    _storeDatePickerData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = null;

        if ($("#" + item.UniqueClientId).data('kendoDatePicker').value() != null && $("#" + item.UniqueClientId).data('kendoDatePicker').value() != '') {
            value = this._serializeDate($("#" + item.UniqueClientId).data('kendoDatePicker').value());
        }

        this.saveDataItem.values['fld_' + item.Id] = value;
    }

    _storeIntegerTextBoxData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = null;

        if ($("#" + item.UniqueClientId).data('kendoNumericTextBox').value() != null) {
            value = $("#" + item.UniqueClientId).data('kendoNumericTextBox').value();
        }

        this.saveDataItem.values['fld_' + item.Id] = value;
    }

    _storeNumericTextBoxData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = null;

        if ($("#" + item.UniqueClientId).data('kendoNumericTextBox').value() != null) {
            value = $("#" + item.UniqueClientId).data('kendoNumericTextBox').value();
        }

        this.saveDataItem.values['fld_' + item.Id] = value;
    }

    _storeTextBoxData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = null;

        if ($("#" + item.UniqueClientId).val() != null && $("#" + item.UniqueClientId).val() != '') {
            value = $("#" + item.UniqueClientId).val();
        }

        this.saveDataItem.values['fld_' + item.Id] = value;
    }

    _storeTextAreaData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = null;

        if ($("#" + item.UniqueClientId).val() != null && $("#" + item.UniqueClientId).val() != '') {
            value = $("#" + item.UniqueClientId).val();
        }

        this.saveDataItem.values['fld_' + item.Id] = value;
    }

    _storeDateTimePickerData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = null;

        if ($("#" + item.UniqueClientId).data('kendoDateTimePicker').value() != null && $("#" + item.UniqueClientId).data('kendoDateTimePicker').value() != '') {
            value = this._serializeDateTime($("#" + item.UniqueClientId).data('kendoDateTimePicker').value());
        }

        this.saveDataItem.values['fld_' + item.Id] = value;
    }

    _serializeDate(date) {
        if (date != null) {
            let result = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
            return result;
        }

        return null;
    }

    _serializeDateTime(date) {
        if (date != null) {
            let result = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + "-" + date.getHours() + "-" + date.getMinutes() + "-" + date.getSeconds();
            return result;
        }

        return null;
    }

    _deserializeDate(date) {
        if (date == null || date == '') {
            return null;
        }
        else {
            var tuples = date.split("-");
            var result = new Date(tuples[0], tuples[1] - 1, tuples[2]);
            return result;
        }
    }

    _deserializeDateTime(date) {
        if (date == null || date == '') {
            return null;
        }
        else {
            var tuples = date.split("-");
            var result = new Date(tuples[0], tuples[1] - 1, tuples[2], tuples[3], tuples[4], tuples[5]);
            return result;
        }
    }

    _storeSwitchData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        if (item.EntityField && item.EntityField.DataType == 'INTEGER') {
            let value = 0;

            if ($("#" + item.UniqueClientId).data('kendoSwitch').check()) {
                value = 1;
            }

            this.saveDataItem.values['fld_' + item.Id] = value;
        } else if (item.EntityField && item.EntityField.DataType == 'BOOLEAN') {
            let value = false;

            if ($("#" + item.UniqueClientId).data('kendoSwitch').check()) {
                value = true;
            }

            this.saveDataItem.values['fld_' + item.Id] = value;
        } else if (item.EntityField && item.EntityField.DataType == 'BOOLINT') {
            let value = 0;

            if ($("#" + item.UniqueClientId).data('kendoSwitch').check()) {
                value = 1;
            }

            this.saveDataItem.values['fld_' + item.Id] = value;
        }
    }

    _storeComboBoxData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = $("#" + item.UniqueClientId).data('kendoComboBox').value();

        if (value != null) {
            this.saveDataItem.values['fld_' + item.Id] = value;
        }
    }

    _storeFileData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        if (this.uploadedFiles[item.UniqueClientId] != null) {
            if (this.uploadedFiles[item.UniqueClientId].uploadedFileAdded) {
                this.saveDataItem.values['fld_' + item.Id] = true;
                this.saveDataItem.values['fld_' + item.Id + '_content'] = this.uploadedFiles[item.UniqueClientId].uploadedFileContent;
                this.saveDataItem.values['fld_' + item.Id + '_fileName'] = this.uploadedFiles[item.UniqueClientId].uploadedFileName;
                this.saveDataItem.values['fld_' + item.Id + '_mimeType'] = this.uploadedFiles[item.UniqueClientId].uploadedFileExtension;
            } else {
                this.saveDataItem.values['fld_' + item.Id] = false;
            }
        } else {
            this.saveDataItem.values['fld_' + item.Id] = null;
        }
    }

    _populateData(item) {
        if (item != null) {
            this.allowEdit = item.xp_allow_edit != null && item.xp_allow_edit == '1';
            this.allowDelete = item.xp_allow_del != null && item.xp_allow_del == '1';

            //if (!this.allowEdit) {
            //    $('#' + this.saveButtonId).remove();
            //} else {
            //    $('#' + this.saveButtonId).show();
            //}

            this.dataItem = item;
            this._populateItem(this.metadata);
        }
    }

    _populateItem(item) {
        if (item.TypeName == 'UIFieldControlDto') {
            if (item.CtlType != null) {
                switch (item.CtlType) {
                    case 'Switch': this._populateSwitchControl(item);
                        break;
                    case 'IntegerTextBox': this._populateIntegerTextBoxControl(item);
                        break;
                    case 'DatePicker': this._populateDatePickerControl(item);
                        break;
                    case 'NumericTextBox': this._populateNumericTextBoxControl(item);
                        break;
                    case 'TextBox': this._populateTextBoxControl(item);
                        break;
                    case 'TextArea': this._populateTextAreaControl(item);
                        break;
                    case 'DateTimePicker': this._populateDateTimePickerControl(item);
                        break;
                    case 'ComboBox': this._populateComboBoxControl(item);
                        break;
                    case 'File': this._populateFileControl(item);
                        break;
                    default: break;
                }
            }
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._populateItem(child);
            });
        }
    }

    _populateDatePickerControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            $("#" + item.UniqueClientId).data("kendoDatePicker").value(this._deserializeDate(this.dataItem['fld_' + item.Id]));
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).data("kendoDatePicker").readonly(true);
        }
    }

    _populateIntegerTextBoxControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            $("#" + item.UniqueClientId).data('kendoNumericTextBox').value(this.dataItem['fld_' + item.Id]);
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).data("kendoNumericTextBox").readonly(true);
        }
    }

    _populateNumericTextBoxControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            $("#" + item.UniqueClientId).data('kendoNumericTextBox').value(this.dataItem['fld_' + item.Id]);
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).data("kendoNumericTextBox").readonly(true);
        }
    }

    _populateTextBoxControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            $("#" + item.UniqueClientId).val(this.dataItem['fld_' + item.Id]);
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).attr('readonly', true);
        }
    }

    _populateTextAreaControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            $("#" + item.UniqueClientId).val(this.dataItem['fld_' + item.Id]);
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).attr('readonly', true);
        }
    }

    _populateDateTimePickerControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            $("#" + item.UniqueClientId).data("kendoDateTimePicker").value(this._deserializeDateTime(this.dataItem['fld_' + item.Id]));
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).data("kendoDateTimePicker").readonly(true);
        }
    }

    _populateSwitchControl(item) {
        if (item.EntityField && item.EntityField.DataType == 'INTEGER') {
            $("#" + item.UniqueClientId).data('kendoSwitch').check(this.dataItem['fld_' + item.Id] == 1);
        } else if (item.EntityField && item.EntityField.DataType == 'BOOLEAN') {
            $("#" + item.UniqueClientId).data('kendoSwitch').check(this.dataItem['fld_' + item.Id] == true);
        } else if (item.EntityField && item.EntityField.DataType == 'BOOLINT') {
            $("#" + item.UniqueClientId).data('kendoSwitch').check(this.dataItem['fld_' + item.Id] == 1);
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).data('kendoSwitch').readonly(true);
        }
    }

    _populateComboBoxControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            $("#" + item.UniqueClientId).data('kendoComboBox').value(this.dataItem['fld_' + item.Id]);

            if (this.allowEdit && !item.IsReadOnly) {
                $("#" + item.UniqueClientId).data("kendoComboBox").readonly(false);
            }

            let cascadeDependants = this._getCascadeDependants(item.Guid);

            if (cascadeDependants != null && cascadeDependants.length > 0) {
                this._handleCascadedItems(cascadeDependants);
            }

            let visibilityDependants = this._getVisibilityDependants(item.Guid);

            if (visibilityDependants != null && visibilityDependants.length > 0) {
                this._handleVisibilityItems(visibilityDependants);
            }
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).data("kendoComboBox").readonly(true);
        }
    }

    _populateFileControl(item) {
        if (this.dataItem['fld_' + item.Id] != null && this.dataItem['fld_' + item.Id] != 'False') {
            let thumb = { name: this.dataItem['fld_' + item.Id + '_file_name'] != null ? this.dataItem['fld_' + item.Id + '_file_name'] : 'N/A' , size: 0, dataURL: rootUrl + 'Entity/GetFileContent?idEntityField=' + item.EntityField.Id + '&pkVal=' + this.objectId };

            $("#" + item.UniqueClientId)[0].dropzone.files.push(thumb);

            $("#" + item.UniqueClientId)[0].dropzone.emit('addedfile', thumb);

            $("#" + item.UniqueClientId)[0].dropzone.createThumbnailFromUrl(thumb,
                $("#" + item.UniqueClientId)[0].dropzone.options.thumbnailWidth, $("#" + item.UniqueClientId)[0].dropzone.options.thumbnailHeight,
                $("#" + item.UniqueClientId)[0].dropzone.options.thumbnailMethod, true, function (thumbnail) {
                    $("#" + item.UniqueClientId)[0].dropzone.emit('thumbnail', thumb, thumbnail);
                });

            $("#" + item.UniqueClientId)[0].dropzone.emit('complete', thumb);

            $("#" + item.UniqueClientId + ' .dz-remove')[0].innerHTML = '';
            $("#" + item.UniqueClientId + ' .dz-remove').addClass('btn btn-danger fal fa-trash-alt d-inline ml-2');
            $("#" + item.UniqueClientId + ' .dz-remove').before('<a class="btn btn-primary fal fa-download d-inline" style="padding-left: 0.5rem; padding-right: 0.5rem; font-size: 14px; text-align: center; display: block; cursor: pointer; border: none;" href="' + rootUrl + 'Entity/GetFileContent?idEntityField=' + item.EntityField.Id + '&pkVal=' + this.objectId + '"></a>');
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if (!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            $("#" + item.UniqueClientId)[0].dropzone.disable();
            $("#" + item.UniqueClientId + ' .dz-remove').remove();
        }
    }

    // init and add events to the created controls

    _initControls(item) {
        if (item.TypeName == 'UIFieldControlDto') {
            if (item.CtlType != null) {
                switch (item.CtlType) {
                    case 'Switch': this._initSwitchControl(item);
                        break;
                    case 'IntegerTextBox': this._initIntegerTextBoxControl(item);
                        break;
                    case 'DatePicker': this._initDatePickerControl(item);
                        break;
                    case 'NumericTextBox': this._initNumericTextBoxControl(item);
                        break;
                    case 'TextBox': this._initTextBoxControl(item);
                        break;
                    case 'TextArea': this._initTextAreaControl(item);
                        break;
                    case 'DateTimePicker': this._initDateTimePickerControl(item);
                        break;
                    case 'ComboBox': this._initComboBoxControl(item);
                        break;
                    case 'File': this._initFileControl(item);
                        break;
                    default: break;
                }
            }
        }

        if (item.TypeName == 'UISublistDto') {
            if ((this.isPreview && item.IdList != null) || (!this.isPreview && this.objectId != null && this.objectId != 'null' && this.objectId != 0 && item.IdList != null)) {
                this._initSublistControl(item);
            }
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._initControls(child);
            });
        }

        if (item.IdVisibilityCommand != null && !this.isPreview) {
            this._hideItem(item);
        }
    }

    _hideItem(item) {
        this._setPersistedState(item, false);
        if (item.TypeName == 'UITabPageDto') {
            $('#' + item.UniqueClientId + '-anchor').parent().hide();
            $('#' + item.UniqueClientId + '-anchor').hide();
        } else {
            $("#" + item.UniqueClientId + "-wrapper").hide();
        }
    }

    _setPersistedState(item, persisted) {
        $("#" + item.UniqueClientId).attr('persisted', persisted);
        if (item.Items != null) {
            item.Items.forEach(child => { this._setPersistedState(child, persisted) });
        }
    }

    _showItem(item) {
        this._setPersistedState(item, true);

        if (item.TypeName == 'UITabPageDto') {
            $('#' + item.UniqueClientId + '-anchor').parent().show();
            $('#' + item.UniqueClientId + '-anchor').show();
        } else {
            $("#" + item.UniqueClientId + "-wrapper").show();
        }
    }

    _bindChangeEvents(item) {
        if (item.TypeName == 'UIFieldControlDto') {
            if (item.CtlType != null) {
                switch (item.CtlType) {
                    case 'ComboBox': this._bindComboBoxChange(item);
                        break;
                    default: break;
                }
            }
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._bindChangeEvents(child);
            });
        }
    }

    _bindComboBoxChange(item) {
        $("#" + item.UniqueClientId).data('kendoComboBox').bind("change", (e) => {
            if (e.sender.value() == null || e.sender.value() == '') {
                e.sender.text('');
                e.sender._oldText = '';
                e.sender._prev = '';
            }

            let cascadeDependants = this._getCascadeDependants(item.Guid);

            if (cascadeDependants != null && cascadeDependants.length > 0) {
                this._handleCascadedItems(cascadeDependants);
            }

            let visibilityDependants = this._getVisibilityDependants(item.Guid);

            if (visibilityDependants != null && visibilityDependants.length > 0) {
                this._handleVisibilityItems(visibilityDependants);
            }
        });
    }

    _checkVisibility(item) {
        if (item.IdVisibilityCommand != null) {
            this.executeCommandById(item.IdVisibilityCommand).then((result) => {
                if (this._parseBooleanCommandResult(result) == true) {
                    this._showItem(item);
                } else {
                    this._hideItem(item);
                }
            });
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._checkVisibility(child);
            });
        }
    }

    _checkItemVisibility(item) {
        if (item.IdVisibilityCommand != null) {
            this.executeCommandById(item.IdVisibilityCommand).then((result) => {
                if (this._parseBooleanCommandResult(result) == true) {
                    this._showItem(item);
                } else {
                    this._hideItem(item);
                }
            });
        }
    }

    _parseBooleanCommandResult(item) {
        if (item == null) {
            return false;
        }

        if (item == 1 || item == '1' || item == true || item == 'true' || item == 'True') {
            return true;
        }

        if (item == 0 || item == '0' || item == false || item == 'false' || item == 'False') {
            return false;
        }

        let keys = Object.keys(item);

        if (keys.length > 0) {
            let value = item[keys[0]];

            if (value == 1 || value == '1' || value == true || value == 'true' || value == 'True') {
                return true;
            }

            if (value == 0 || value == '0' || value == false || value == 'false' || value == 'False') {
                return false;
            }
        }

        return false;
    }

    _initDatePickerControl(item) {
        let options = {};

        if (item.Format != null && item.Format.trim() != '') {
            options.format = item.Format;
        }

        $("#" + item.UniqueClientId).kendoDatePicker(options);

        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).data("kendoDatePicker").readonly(true);
        }
    }

    _initIntegerTextBoxControl(item) {
        let format = "0";

        if (item.Format != null && item.Format.trim() != '') {
            format = item.Format;
        }

        $("#" + item.UniqueClientId).kendoNumericTextBox({
            format: format,
            decimals: 0
        });

        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).data("kendoNumericTextBox").readonly(true);
        }
    }

    _initNumericTextBoxControl(item) {
        let options = {};

        if (item.Format != null && item.Format.trim() != '') {
            options.format = item.Format;
        }

        $("#" + item.UniqueClientId).kendoNumericTextBox(options);

        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).data("kendoNumericTextBox").readonly(true);
        }
    }

    _initTextBoxControl(item) {
        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).attr('readonly', true);
        }
    }

    _initTextAreaControl(item) {
        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).attr('readonly', true);
        }
    }

    _initDateTimePickerControl(item) {
        let options = {};

        if (item.Format != null && item.Format.trim() != '') {
            options.format = item.Format;
        }

        $("#" + item.UniqueClientId).kendoDateTimePicker(options);

        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).data("kendoDateTimePicker").readonly(true);
        }
    }

    _initSwitchControl(item) {
        $("#" + item.UniqueClientId).kendoSwitch({
            messages: {
                checked: this._getResource('SWITCH_ON'),
                unchecked: this._getResource('SWITCH_OFF')
            },
            checked: false,
            change: (e) => {
                let visibilityDependants = this._getVisibilityDependants(item.Guid);

                if (visibilityDependants != null && visibilityDependants.length > 0) {
                    this._handleVisibilityItems(visibilityDependants);
                }
            }
        });

        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).data('kendoSwitch').readonly(true);
        }
    }

    _initSublistControl(item) {
        if (item.IdList == null || item.IdList == '') {
            return;
        }

        let sublistUrl = '';

        if (this.isPreview) {
            sublistUrl = rootURL + 'EntityList/EntitySubListRuntime?IdList=' + item.IdList + '&pageGuid=' + this._generateUUID();
        } else {
            sublistUrl = rootURL + 'EntityList/EntitySubListRuntime?idUISubList=' + item.Id + '&pkVal=' + this.objectId + '&pageGuid=' + this._generateUUID();
        }

        $.ajax({
            type: "GET",
            url: sublistUrl,
            contentType: "application/json; charset=utf-8",
            success: (listMeta) => {
                $('#' + item.UniqueClientId).append('<script>' + listMeta.CustomJs + '</script>');
                let filterId = listMeta.IdFilter != null ? listMeta.IdFilter : -1;

                listMeta.Context = '';
                listMeta.CurrentUrl = 'full';
                listMeta.ReturnUrl = '';
                listMeta.ContainerId = item.UniqueClientId;
                listMeta.Template = 'standard';
                listMeta.GeneralResources = this.generalResources;
                listMeta.EntityFormResources = this.customFormResources;
                listMeta.UiActionResources = this.actionLocalization;
                listMeta.RootUrl = rootUrl;
                listMeta.IsPreview = this.isPreview;
                listMeta.LayoutResources = this.localization;
                listMeta.FilterId = filterId;
                listMeta.Parent = this;
                listMeta.uiLayoutId = item.Id;
                listMeta.parentPkVal = this.objectId;

                let sublistControl = new ListControl(listMeta);

                if (filterId != -1) {
                    $.ajax({
                        type: "GET",
                        url: rootUrl + 'UILayout/GetUILayoutRuntime?id=' + filterId,
                        contentType: "application/json; charset=utf-8",
                        success: (result) => {
                            if (sublistControl.filterControl != null) {
                                sublistControl.filterControl.loadForm(result);
                            }
                        },
                        error: (e) => {
                            toastr.error(e.responseText, this._getResource('GetLayoutError'));
                        }
                    });
                }
            },
            error: (e) => {
                toastr.error(e.responseText, this._getResource('GetSublistError'));
            }
        });
    }

    _initComboBoxControl(item) {
        $("#" + item.UniqueClientId).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            template: (dataItem) => {
                if (dataItem.Attr != null && dataItem.Attr.length == 2 && dataItem.Attr[1] != null) {
                    return '<img src="' + (rootUrl + 'Entity/GetFileContent?idEntityField=' + dataItem.Attr[1] + '&pkVal=' + dataItem.Id) + '" width="60" height="60" /><span class="k-state-default ml-2">' + dataItem.Name + '</span>'
                } else {
                    return '<span class="k-state-default ml-2">' + dataItem.Name + '</span>';
                }
            },
            dataSource: {
                serverFiltering: true,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            if (item.DependsOnGuids != null && item.DependsOnGuids.length > 0) {
                                let isReadonly = false;
                                let filter = {};

                                item.DependsOnGuids.forEach(depends => {
                                    let item = this._getItemByGuid(depends, [this.metadata]);
                                    let value = this._getItemValueByGuid(depends);

                                    if (value == null || value == '') {
                                        value = -1;
                                    }

                                    filter[item.EntityField.FieldName] = value;

                                    if (value == null || value == '') {
                                        isReadonly = true;
                                    }
                                });

                                if (this.isPreview) {
                                    return rootURL + 'Entity/GetEmptyFieldSource?idField=' + item.Id + '&filter=' + JSON.stringify(filter) + '&search=' + $('#' + item.UniqueClientId).data('kendoComboBox').text();;
                                }

                                if (isReadonly) {
                                    $('#' + item.UniqueClientId).data("kendoComboBox").value(null);
                                    $('#' + item.UniqueClientId).data("kendoComboBox").readonly(true);
                                    return rootURL + 'Entity/GetFieldSource?idField=' + item.Id;
                                } else {
                                    return rootURL + 'Entity/GetFieldSource?idField=' + item.Id + '&filter=' + JSON.stringify(filter);
                                }
                            } else {
                                return rootURL + 'Entity/GetFieldSource?idField=' + item.Id + '&search=' + $('#' + item.UniqueClientId).data('kendoComboBox').text();
                            }
                        }
                    }
                }
            }
        });

        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).data("kendoComboBox").readonly(true);
        }
    }

    _handleVisibilityItems(dependants) {
        dependants.forEach(dependant => {
            this._checkItemVisibility(dependant);
        });
    }

    _handleCascadedItems(dependants) {
        dependants.forEach(dependant => {
            switch (dependant.CtlType) {
                case 'ComboBox': this._handleCascadedCombobox(dependant);
                    break;
                default: break;
            }
        });
    }

    _handleCascadedCombobox(item) {
        let isEligible = true;

        item.DependsOnGuids.forEach(dependsOn => {
            let value = this._getItemValueByGuid(dependsOn);

            if (value == null || value == '') {
                isEligible = false;
            }
        });

        if (isEligible) {
            $('#' + item.UniqueClientId).data("kendoComboBox").readonly(false);
            $('#' + item.UniqueClientId).data("kendoComboBox").value(null);
            $('#' + item.UniqueClientId).data("kendoComboBox").trigger('change');
            $('#' + item.UniqueClientId).data("kendoComboBox").dataSource.read();
        } else {
            $('#' + item.UniqueClientId).data("kendoComboBox").value(null);
            $('#' + item.UniqueClientId).data("kendoComboBox").trigger('change');
            $('#' + item.UniqueClientId).data("kendoComboBox").readonly(true);
        }
    }

    _getItemValueByGuid(guid) {
        let item = this._getItemByGuid(guid, [this.metadata]);
        let result = null;
        if (item != null) {
            switch (item.CtlType) {
                case 'ComboBox': result = $('#' + item.UniqueClientId).data('kendoComboBox').value();
                    break;
                case 'IntegerTextBox': result = $('#' + item.UniqueClientId).data('kendoNumericTextBox').value();
                    break;
                default: break;
            }
        }

        return result;
    }

    _getItemByGuid(guid, items) {
        for (var item of items) {
            if (guid == item.Guid) {
                return item;
            }
            if (item.Items) {
                var result = this._getItemByGuid(guid, item.Items);
                if (result) {
                    return result;
                }
            }
        }
        return null;
    }

    _getVisibilityDependants(itemId) {
        let result = [];

        this._searchVisibilityDependantItem(this.metadata, itemId, result);

        return result;
    }

    _searchVisibilityDependantItem(item, itemId, resultBag) {
        if (item.VisibilityDependsOnGuids != null && item.VisibilityDependsOnGuids.length > 0) {
            let matches = item.VisibilityDependsOnGuids.filter(row => { return row == itemId; });

            if (matches != null && matches.length > 0) {
                resultBag.push(item);
            }
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._searchVisibilityDependantItem(child, itemId, resultBag);
            });
        }
    }

    _getCascadeDependants(itemId) {
        let result = [];

        this._searchCascadeDependantItem(this.metadata, itemId, result);

        return result;
    }

    _searchCascadeDependantItem(item, itemId, resultBag) {
        if (item.DependsOnGuids != null && item.DependsOnGuids.length > 0) {
            let matches = item.DependsOnGuids.filter(row => { return row == itemId; });

            if (matches != null && matches.length > 0) {
                resultBag.push(item);
            }
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._searchCascadeDependantItem(child, itemId, resultBag);
            });
        }
    }

    _initFileControl(item) {
        const currentFormControl = this;

        $("#" + item.UniqueClientId).dropzone({
            url: "/fakeURL",
            method: "post",
            autoProcessQueue: false,
            paramName: "file",
            uploadMultiple: false,
            maxFiles: 1,
            thumbnailWidth: 260,
            thumbnailHeight: 260,
            addRemoveLinks: true,
            dictRemoveFile: this._getResource('File_RemoveUpload'),
            init: function () {

                var wrapperThis = this;

                this.on("addedfile", function (file) {

                    if (this.files[1] != null) {
                        this.removeFile(this.files[0]);
                    }

                    $('#' + item.UniqueClientId + '-img').hide();
                    $('#' + item.UniqueClientId + '-label').hide();

                    wrapperThis.emit("complete", file);
                    $(".dz-size").remove();
                    $(".dz-progress").remove();
                    $(".dz-error-message").remove();
                    $(".dz-success-mark").remove();
                    $(".dz-error-mark").remove();

                    if ($('#' + item.UniqueClientId + '-details-buttons').length > 0) {
                        $('#' + item.UniqueClientId + '-details-buttons').remove();
                    }

                    $("#" + item.UniqueClientId).append('<div class="dz-details-buttons" id="' + item.UniqueClientId + '-details-buttons"></div>');

                    $("#" + item.UniqueClientId + ' .dz-remove').appendTo($('#' + item.UniqueClientId + '-details-buttons'));
                    $("#" + item.UniqueClientId + ' .dz-remove')[0].innerHTML = '';
                    $("#" + item.UniqueClientId + ' .dz-remove').addClass('btn btn-danger fal fa-trash-alt d-inline');
                });

                this.on("removedfile", function (file) {
                    $('#' + item.UniqueClientId + '-details-buttons').remove();
                    $('#' + item.UniqueClientId + '-img').show();
                    $('#' + item.UniqueClientId + '-label').show();
                    if (currentFormControl.uploadedFiles[item.UniqueClientId] != null) {
                        currentFormControl.uploadedFiles[item.UniqueClientId].uploadedFileAdded = false;
                    }
                });
            },

            accept: function (file, done) {
                const fileName = file.name;
                const fileExtension = file.type;
                const reader = new FileReader();
                reader.addEventListener("loadend", (event) => {
                    if (currentFormControl.uploadedFiles[item.UniqueClientId] == null) {
                        currentFormControl.uploadedFiles[item.UniqueClientId] = {};
                    }
                    currentFormControl.uploadedFiles[item.UniqueClientId].uploadedFileAdded = true;
                    currentFormControl.uploadedFiles[item.UniqueClientId].uploadedFileContent = reader.result;
                    currentFormControl.uploadedFiles[item.UniqueClientId].uploadedFileName = fileName;
                    currentFormControl.uploadedFiles[item.UniqueClientId].uploadedFileExtension = fileExtension;
                });
                reader.readAsDataURL(file);
            }
        });

        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId)[0].dropzone.disable();
        }
    }

    _getTemplate() {
        let template = ``;

        if (this.metadata.UniqueClientId == null) {
            this.metadata.UniqueClientId = this._generateUUID();
        }

        if (this.metadata.TypeName == 'UILayoutDto') {
            template += `<div class="form-layout-wrapper" style="height: ` + (this.parentGuid != null ? `auto` : `calc(100% - 3.4rem)`) + `; ` + this._getWrapperStyle(this.metadata) + `"` + `" id="` + this.metadata.UniqueClientId + `-wrapper` + `"><div class="panel-content form-row col-sm-12` + (this.isFilter ? ` pr-2 pl-3 mt-3` : ``) + this._getClassName(this.metadata) + `" ui-type="` + this.metadata.TypeName + `" ui-id="` + this.metadata.Id + `" ui-entity-id="` + this.metadata.IdEntity + `" id="` + this.metadata.UniqueClientId + `"` + (this.metadata != null && this.metadata != '' ? ` ui-name="` + this.metadata.Name + `"` : ``) + ` style="` + this._getInnerStyle(this.metadata) + `"` + this._getAttributes(this.metadata) + `>`;

            if (this.metadata.Description != null && this.metadata.Description.trim() != '') {
                template += `<div class="form-row col-sm-12" style="margin-left: 0 !important; margin-right: 0 !important; ` + this._getDescriptionStyle(this.metadata) + `">` + this.metadata.Description + `</div>`;
            }
            template += this._getChildrenTemplate(this.metadata);

            if (this.isFilter) {
                template += this._getButtons();
                template += `</div></div>`;
            }
            else {
                template += `</div></div>`;
                template += this._getButtons();
            }

            template += `<div id="` + this.uniqueModalId + `"></div>`;
        }

        return template;
    }

    _getButtons() {
        let template = ``;

        if (this.isFilter) {
            template = `<div class="col-sm-12 mb-2">
                            <div class="form-group d-flex">
                                <button class="btn btn-secondary ml-auto" id="` + this.clearFilterButtonId + `" title="` + this._getResource('ClearFilter') + `" type="button"` + (this.isPreview ? ` disabled="disabled"` : ``) + `>` + this._getResource('ClearFilter') + `</button>
                                <button class="btn btn-primary ml-2" id="` + this.searchFilterButtonId + `" title="` + this._getResource('Filter') + `" type="button"` + (this.isPreview ? ` disabled="disabled"` : ``) + `>` + this._getResource('Filter') + `</button>
                            </div>
                        </div>`;
        } else {
            template = `<div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right pr-0 pb-0 pt-2 pl-0 ` + (this.parentGuid != null && this.parentGuid != '' ? `mr-0 ml-0` : `mr-3 ml-3 pb-2`) + `"` + (this.parentGuid != null && this.parentGuid != '' ? ` style="padding-bottom: 0.5rem !important;"` : ``) + `>` +
                                this._getActionButtons()
                            + `</div>`;
                            //<div class="ml-auto"></div>
                            //<button class="btn btn-primary ml-2" style="display: none;" id="` + this.saveButtonId + `" title="` + this._getResource('Save') + `" type="button"` + (this.isPreview ? ` disabled="disabled"` : ``) + `>` + this._getResource('Save') + `</button>
                            //<button class="btn btn-secondary ml-2" id="` + this.cancelButtonId + `" title="` + this._getResource('Cancel') + `" type="button"` + (this.isPreview ? ` disabled="disabled"` : ``) + `>` + this._getResource('Cancel') + `</button>
                        
        }

        return template;
    }

    _getActionButtons() {
        let template = ``;
        let idx = 0;

        let hasMargin = false;

        this.actionButtons.forEach(actionButton => {
            if (actionButton.ClassName != null && actionButton.ClassName.indexOf('ml-auto') >= 0) {
                hasMargin = true;
            }
        });

        this.actionButtons.forEach(actionButton => {
            if (actionButton.SubType == 'SAVE' && !hasMargin) {
                actionButton.ClassName += ' ml-auto';
            } else if (actionButton.SubType == 'APPLY' && !hasMargin) {
                let saveExists = false;

                this.actionButtons.forEach(actionButton => {
                    if (actionButton.SubType == 'SAVE') {
                        saveExists = true;
                    }
                });

                if (!saveExists) {
                    actionButton.ClassName += ' ml-auto';
                }
            } else if (actionButton.SubType == 'CANCEL' && !hasMargin) {
                let saveExists = false;
                let applyExists = false;

                this.actionButtons.forEach(actionButton => {
                    if (actionButton.SubType == 'SAVE') {
                        saveExists = true;
                    } else if (actionButton.SubType == 'APPLY') {
                        applyExists = true;
                    }
                });

                if (!saveExists & !applyExists) {
                    actionButton.ClassName += ' ml-auto';
                }
            }

            let otherAttributes = '';

            if (actionButton.HtmlAttributes != null && actionButton.HtmlAttributes != '') {
                var attrKeys = [];

                if (actionButton.HtmlAttributes.toJSON != null) {
                    attrKeys = Object.keys(actionButton.HtmlAttributes.toJSON());
                } else {
                    attrKeys = Object.keys(actionButton.HtmlAttributes);
                }

                for (var i = 0; i < attrKeys.length; i++) {
                    otherAttributes += actionButton.HtmlAttributes[attrKeys[i]] + ' ';
                }
            }

            let actionButtonIconTemplate = ``;

            if (actionButton.Icon != null && actionButton.Icon != '') {
                actionButtonIconTemplate = `<i class="` + actionButton.Icon + ` mr-2"></i>`
            }

            template += `<button id="form-action-` + (actionButton.Id != 0 ? actionButton.Id : this.currentActionId) + `" class="btn ` + actionButton.ClassName + `" ` + otherAttributes + ` title="` + this._getActionResource(actionButton.Text) + `" type="button"` + (this.isPreview ? ` disabled="disabled"` : ``) + (this.isPreview ? `` : ` style="display:none;"`) + `">` + actionButtonIconTemplate + this._getActionResource(actionButton.Text) + `</button>`;

            if (actionButton.Id == 0) {
                this.currentActionId--;
            }
            idx++;
        });

        return template;
    }



    _getChildrenTemplate(item){
        let template = ``;

        if(item.Items != null && item.Items.length > 0){
            item.Items.forEach(child => {
                if (child.UniqueClientId == null) {
                    child.UniqueClientId = this._generateUUID();
                }

                switch(child.TypeName){
                    case 'UITabControlDto': template += this._getTabControlTemplate(child);
                        break;
                    case 'UITabPageDto': template += this._getTabPageTemplate(child);
                        break;
                    case 'UIGroupDto': template += this._getCollapsableGroupTemplate(child);
                        break;
                    case 'UIParagraphDto': template += this._getParagraphTemplate(child);
                        break;
                    case 'UISublistDto': template += this._getSublistTemplate(child);
                        break;
                    case 'UIFieldControlDto': template += this._getFieldControlTemplate(child);
                        break;
                    default: template += ``;
                        break;
                }
            });
        }

        return template;
    }

    _getTabControlTemplate(item) {
        let template = `<div class="panel-content p-0` + this._getLayoutCols(item) + this._getClassName(item) + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `" id="` + item.UniqueClientId + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getWrapperStyle(item) + `"` + this._getAttributes(item) + `><ul class="nav nav-tabs" role="tablist">`;

        if (item.Items != null && item.Items.length > 0) {
            let firstActive = false;
            let pagesCount = 0;
            item.Items.forEach(child => {
                if (child.TypeName == 'UITabPageDto') {
                    if (child.UniqueClientId == null) {
                        child.UniqueClientId = this._generateUUID();
                    }

                    if (!firstActive) {
                        child.IsPageActive = true;
                    } else {
                        child.IsPageActive = false;
                    }

                    template += `<li class="nav-item" onclick="` + this.uniqueId + `._tabOnClick('` + child.UniqueClientId + `')" style="cursor: pointer; ` + this._getPageButtonStyle(item) + `"><a id="` + child.UniqueClientId + `-anchor" class="nav-link` + (!firstActive ? ` active` : ``) + `" data-toggle="tab" role="tab" style=` + this._getPageLinkStyle(item) + `>` + (child.Text != null ? child.Text : this._getResource(child.TypeName)) + `</a></li>`;

                    firstActive = true;
                    pagesCount++;
                }
            });

            if (pagesCount == 0) {
                return ``;
            }
        } else {
            return ``;
        }

        template += `</ul>`;

        template += `<div class="tab-content p-0 pt-3" style="` + this._getPageWrapperStyle(item) + `">`;
        template += this._getChildrenTemplate(item);
        template += `</div></div>`;

        return template;
    }

    _getTabPageTemplate(item) {
        let template = `<div class="tab-pane fade` + (item.IsPageActive ? ` show active` : ``) + this._getClassName(item) + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `" id="` + item.UniqueClientId + `" role="tabpanel"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getWrapperStyle(item) + ` display: flex; flex-wrap: wrap;"` + this._getAttributes(item) + `>`;
        template += this._getChildrenTemplate(item);
        template += `</div>`;
        return template;
    }

    _getCollapsableGroupTemplate(item) {
        let template = `<div class="accordion accordion-outline` + this._getLayoutCols(item) + this._getClassName(item) + `" id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getWrapperStyle(item) + `"` + this._getAttributes(item) + `>`;
        template += `<div class="card" style="` + this._getCardStyle(item) + `">`;
        template += `<div class="card-header" style="height: 2rem; ` + this._getCardHeaderStyle(item) + `" onclick="` + this.uniqueId + `._accordionOnClick('` + item.UniqueClientId + `', ` + item.Collapsable + `)">
                        <a id="` + item.UniqueClientId + `-anchor" href="javascript:void(0);" class="card-title` + (item.Collapsed ? ' collapsed' : ``) + `" style="padding: 0.5rem 0.5rem; ` + this._getCardHeaderLabelStyle(item) + `" aria-expanded="` + (!item.Collapsed ? 'true' : `false`) + `">` +
                            (item.Text != null ? item.Text : this._getResource(item.TypeName))
                           + `<span class="ml-auto">
                                <span class="collapsed-reveal">
                                    <i class="fal fa-minus fs-xl"></i>
                                </span>
                                <span class="collapsed-hidden">
                                    <i class="fal fa-plus fs-xl"></i>
                                </span>
                            </span>
                        </a>
                    </div>`;
        template += `<div id="` + item.UniqueClientId + `-inner" class="collapse` + (!item.Collapsed ? ' show' : ``) + `" style="` + this._getCardInnerStyle(item) + `">
                                <div class="card-body form-row">`;
        template += this._getChildrenTemplate(item);
        template += `</div>`;
        template += `</div>`;
        template += `</div>`;
        template += `</div>`;

        return template;
    }

    _getParagraphTemplate(item) {
        let template = `<div class="` + this._getLayoutCols(item) + this._getClassName(item) + ` form-group" id="` + item.UniqueClientId + `-wrapper" style="` + this._getWrapperStyle(item) + `">`;

        if (item.Label != null && item.Label.trim() != '') {
            template += `<label class="form-label" style="` + this._getLabelStyle(item) + `">` + item.Label + `</label>`;
        }

        if (item.Description != null && item.Description.trim() != '') {
            template += `<div class="form-field-description" style="padding: 0.5rem 0.5rem; margin-bottom: 0.5rem; background: #eef7fd; opacity: 0.8; font-weight: 400; font-size: 0.875rem; border-radius: 8px; width: fit-content; ` + this._getDescriptionStyle(item) + `"><span style="color:indianred; padding-right: 0.25rem;">*</span>` + item.Description + `</div>`;
        }

        template += `<div class="form-row mr-0 ml-0 col-12` + this._getClassName(item) + `" id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInnerStyle(item) + `"` + this._getAttributes(item) + `>`;
        template += this._getChildrenTemplate(item);
        template += `</div>`;
        template += `</div>`;

        return template;
    }

    _getSublistTemplate(item) {
        let template = `<div class="` + this._getLayoutCols(item) + this._getClassName(item) + ` form-group" id="` + item.UniqueClientId + `-wrapper" style="` + this._getWrapperStyle(item) + `">`;
        if (item.Label != null && item.Label.trim() != '') {
            template += `<label class="form-label" style="` + this._getLabelStyle(item) + `">` + item.Label + `</label>`;
        }
        
        if (item.Description != null && item.Description.trim() != '') {
            template += `<div class="form-field-description" style="padding: 0.5rem 0.5rem; margin-bottom: 0.5rem; background: #eef7fd; opacity: 0.8; font-weight: 400; font-size: 0.875rem; border-radius: 8px; width: fit-content; ` + this._getDescriptionStyle(item) + `"><span style="color:indianred; padding-right: 0.25rem;">*</span>` + item.Description + `</div>`;
        }

        template += `<div id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInnerStyle(item) + `"` + this._getAttributes(item) + `></div>`;

        template += `</div>`;

        return template;
    }

    _getFieldControlTemplate(item) {
        let wrapperStyle = '';

        //if (item.Hidden) {
        //    wrapperStyle = 'style="display: none;"';
        //}

        if (!this.isFilter) {
            wrapperStyle = 'display: none;';
        } else if (item.Hidden) {
            wrapperStyle = 'display: none;';
        }

        let template = `<div class="form-group` + this._getLayoutCols(item) + this._getClassName(item) + `" id="` + item.UniqueClientId + `-wrapper" style="` + wrapperStyle + this._getWrapperStyle(item) + `">`;

        if (item.CtlType == 'Switch') {
            template += `<label class="form-label col-sm-12 pl-0" style="` + this._getLabelStyle(item) + `">` + (item.Label != null ? item.Label : 'N/A') + `</label>`;
            if (item.Description != null && item.Description.trim() != '') {
                template += `<div class="form-field-description col-sm-12" style="padding: 0.5rem 0.5rem; margin-bottom: 0.5rem; background: #eef7fd; opacity: 0.8; font-weight: 400; font-size: 0.875rem; border-radius: 8px; width: fit-content; ` + this._getDescriptionStyle(item) + `"><span style="color:indianred; padding-right: 0.25rem;">*</span>` + item.Description + `</div>`;
            }
            template += this._getFieldTypeControlTemplate(item);
        } else {
            template += `<label class="form-label" style="` + this._getLabelStyle(item) + `">` + (item.Label != null ? item.Label : 'N/A') + `</label>`;
            if (item.Description != null && item.Description.trim() != '') {
                template += `<div class="form-field-description" style="padding: 0.5rem 0.5rem; margin-bottom: 0.5rem; background: #eef7fd; opacity: 0.8; font-weight: 400; font-size: 0.875rem; border-radius: 8px; width: fit-content; ` + this._getDescriptionStyle(item) + `"><span style="color:indianred; padding-right: 0.25rem;">*</span>` + item.Description + `</div>`;
            }
            template += this._getFieldTypeControlTemplate(item);
        }

        template += `</div>`;

        return template;
    }

    _getFieldTypeControlTemplate(item) {
        let template = ``;

        if (item.CtlType != null) {
            switch (item.CtlType) {
                case 'Switch': template = this._getSwitchFieldTypeControlTemplate(item);
                    break;
                case 'IntegerTextBox': template = this._getIntegerTextBoxFieldTypeControlTemplate(item);
                    break;
                case 'NumericTextBox': template = this._getNumericTextBoxFieldTypeControlTemplate(item);
                    break;
                case 'TextBox': template = this._getTextBoxFieldTypeControlTemplate(item);
                    break;
                case 'TextArea': template = this._getTextAreaFieldTypeControlTemplate(item);
                    break;
                case 'DatePicker': template = this._getDatePickerFieldTypeControlTemplate(item);
                    break;
                case 'DateTimePicker': template = this._getDateTimePickerFieldTypeControlTemplate(item);
                    break;
                case 'ComboBox': template = this._getComboBoxFieldTypeControlTemplate(item);
                    break;
                case 'File': template = this._getFileFieldTypeControlTemplate(item);
                    break;
                default: template = ``;
                    break;
            }
        }

        return template;
    }

    _getSwitchFieldTypeControlTemplate(item) {
        return `<div id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `></div>`;
    }

    _getIntegerTextBoxFieldTypeControlTemplate(item) {
        return `<input id="` + item.UniqueClientId + `" class="form-control" autocomplete="off" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `/>`;
    }

    _getNumericTextBoxFieldTypeControlTemplate(item) {
        return `<input id="` + item.UniqueClientId + `" class="form-control" autocomplete="off" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `/>`;
    }

    _getTextBoxFieldTypeControlTemplate(item) {
        return `<input type="text" id="` + item.UniqueClientId + `" class="form-control" autocomplete="off" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `/>`;
    }

    _getTextAreaFieldTypeControlTemplate(item) {
        return `<textarea id="` + item.UniqueClientId + `" class="form-control" autocomplete="off" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `></textarea>`;
    }

    _getDatePickerFieldTypeControlTemplate(item) {
        return `<input id="` + item.UniqueClientId + `" class="form-control" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` autocomplete="off" style="` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `/>`;
    }

    _getDateTimePickerFieldTypeControlTemplate(item) {
        return `<input id="` + item.UniqueClientId + `" class="form-control" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` autocomplete="off" style="` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `/>`;
    }

    _getFileFieldTypeControlTemplate(item) {
        return `<div class="dropzone needsclick d-block d-flex justify-content-center align-items-center" id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="width: 100%; ` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `>
                    <div class="dz-message needsclick" style="margin:auto;">
                        <i class="fal fa-cloud-upload text-muted" id="` + item.UniqueClientId + `-img" style="justify-content: center; display: flex;"></i>
                        <span class="text-uppercase ml-2" style="text-align: center;" id="` + item.UniqueClientId + `-label">` + this._getResource('File_UploadHint') + `</span>
                    </div>
                </div>`;
    }

    _getComboBoxFieldTypeControlTemplate(item) {
        return `<div id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="width: 100%; ` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `></div>`;
    }

    _disposeForm() {
        this.metadata = null;
        $('#' + this.container)[0].innerHTML = '';
    }

    _getResource(name) {
        if (this.localization[name] != null && this.localization[name].trim() != '') {
            return this.localization[name];
        }

        return name;
    }

    _getCustomFormResource(name) {
        if (this.customFormResources[name] != null && this.customFormResources[name].trim() != '') {
            return this.customFormResources[name];
        }

        return name;
    }

    _getActionResource(name) {
        if (name == 'EDIT' || name == 'DELETE' || name == 'SHOW_IN_MAP' || name == 'EDIT_GEOMETRY' || name == 'SAVE' || name == 'CANCEL' || name == 'APPLY' || name == 'SELECT_FROM_MAP') {
            name = 'ElementAction_' + name;
        }

        if (this.actionLocalization[name] != null && this.actionLocalization[name].trim() != '') {
            return this.actionLocalization[name];
        }

        return name;
    }

    _tabOnClick(id) {
        $('#' + id).parent().parent().find('.nav-link').removeClass('active');
        $('#' + id).parent().parent().find('.nav-link').attr('aria-selected', 'false');
        $('#' + id + '-anchor').addClass('active');
        $('#' + id + '-anchor').attr('aria-selected', 'true');

        $('#' + id).addClass('show');
        $('#' + id).addClass('active');

        $('#' + id).siblings().removeClass('show');
        $('#' + id).siblings().removeClass('active');

        let lists = $('.k-grid-header');

        for (var i = 0; i < lists.length; i++) {
            let list = lists[i];
            let listItem = $(list).parent();

            if (listItem.data('kendoGrid')._resizeHandler) {
                listItem.data('kendoGrid')._resizeHandler();
            }

            let listItemId = listItem.attr('id').replaceAll('entity_list_', '');

            if (window['listControl' + listItemId] != null) {
                window['listControl' + listItemId]._adjustLastColumn();
            }

            
        }

        this.lastChosenTab = id;
    }

    _accordionOnClick(id, collapsable) {
        if (collapsable) {
            if ($('#' + id + '-anchor').hasClass('collapsed')) {
                $('#' + id + '-anchor').attr('aria-expanded', true);
                $('#' + id + '-anchor').removeClass('collapsed');
                $('#' + id + '-inner').addClass('show');
            } else {
                $('#' + id + '-anchor').attr('aria-expanded', false);
                $('#' + id + '-anchor').addClass('collapsed');
                $('#' + id + '-inner').removeClass('show');
            }
        }
    }

    _generateUUID() {
        var d = new Date().getTime();
        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16;
            if (d > 0) {
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        }).replaceAll('-', '');
    }

    _getLayoutCols(item) {
        if (item.LayoutCols != null && item.LayoutCols != '' && item.LayoutCols > 0) {
            if (item.LayoutCols > 12) {
                return ' col-sm-12';
            } else {
                return ' col-sm-' + item.LayoutCols;
            }
        } else if (item.TypeName == 'UIFieldControlDto') {
            return ' col-sm-6';
        }

        return ' col-sm-12';
    }

    _getClassName(item) {
        if (item.ClassName != null && item.ClassName != '') {
            return ' ' + item.ClassName;
        }

        return '';
    }

    _getStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '') {
            return style + item.Style.trim();
        } else {
            return style;
        }
    }

    _getWrapperStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleWrapper != null) {
            return style + JSON.parse(item.Style).styleWrapper.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getInputStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleInput != null) {
            return style + JSON.parse(item.Style).styleInput.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getDescriptionStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleDescription != null) {
            return style + JSON.parse(item.Style).styleDescription.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getLabelStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleLabel != null) {
            return style + JSON.parse(item.Style).styleLabel.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getInnerStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleInner != null) {
            return style + JSON.parse(item.Style).styleInner.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getPageButtonStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).stylePageButton != null) {
            return style + JSON.parse(item.Style).stylePageButton.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getPageLinkStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).stylePageLink != null) {
            return style + JSON.parse(item.Style).stylePageLink.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getPageWrapperStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).stylePageWrapper != null) {
            return style + JSON.parse(item.Style).stylePageWrapper.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getCardStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleCard != null) {
            return style + JSON.parse(item.Style).styleCard.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getCardHeaderStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleCardHeader != null) {
            return style + JSON.parse(item.Style).styleCardHeader.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getCardHeaderLabelStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleCardHeaderLabel != null) {
            return style + JSON.parse(item.Style).styleCardHeaderLabel.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getCardInnerStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleCardInner != null) {
            return style + JSON.parse(item.Style).styleCardInner.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getAttributes(item) {
        if (item.HtmlAttributes != null) {
            let attributes = '';

            let keys = Object.keys(item.HtmlAttributes);

            for (var i = 0; i < keys.length; i++) {
                if (keys[i] != '_events' && keys[i] != '_handlers' && keys[i] != 'uid' && keys[i] != 'parent') {
                    attributes += ' ' + keys[i] + '="' + item.HtmlAttributes[keys[i]] + '"';
                }
            }

            return attributes;
        } else {
            return '';
        }
    }

    getItemById(id) {
        return $('#' + id);
    }
}